import { Select } from '@melements/front-components';
import React, { useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Column, LocaleContext, Row } from 'shared';

import { AddNewLockFormLabel } from '../../AddNewLockForm.styles';

import { BankEnvironmentProps } from './BankEnvironment.types';

const formatSelectValue = (value?: any) => (value ? { value, label: value } : undefined);
const parseSelectValue = (value?: any) => (value ? value.value : '');

export const BankEnvironment = ({ bankEnvironments, selectBankEnvironment }: BankEnvironmentProps) => {
  const localeContext = useContext(LocaleContext);

  const handleChange = (selectedValue: string) => {
    selectBankEnvironment(selectedValue);
  };

  return (
    <Row>
      <Column size={[12]}>
        <AddNewLockFormLabel>
          {localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.CHOOSE-ENVIRONMENT' })}
        </AddNewLockFormLabel>
      </Column>
      <Column size={[6]}>
        <Field name="bankId" format={formatSelectValue} parse={parseSelectValue}>
          {({ input, meta }: { meta: FieldRenderProps<any>['meta']; input: any }) => (
            <Select
              defaultValue={bankEnvironments ? bankEnvironments[0] : undefined}
              placeholder={localeContext.formatMessage({ id: 'ENDPOINTS.FORM.ADD_NEW_LOCK.BANK_ENVIRONMENT' })}
              input={input}
              meta={meta}
              className="add-new-lock-form__bank-environment"
              options={bankEnvironments}
              menuPlacement="top"
            />
          )}
        </Field>
        <OnChange name="bankId">
          {(value: string) => {
            handleChange(value);
          }}
        </OnChange>
      </Column>
    </Row>
  );
};
